module.exports = __webpack_public_path__ + "static/media/bch-coin.7325e6e5.png";